export default __webpack_public_path__ + "static/media/behance-24-px.c76770d8.svg";